var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C3.89543 0 3 0.895431 3 2L3 7.20703C3.32228 7.11588 3.65659 7.05337 4 7.02242V2C4 1.44772 4.44772 1 5 1L9 1V4.5C9 5.32843 9.67157 6 10.5 6H14V14C14 14.5523 13.5523 15 13 15H9.40029C9.21739 15.3578 8.99647 15.6929 8.74284 16H13C14.1046 16 15 15.1046 15 14V5.41421C15 5.01639 14.842 4.63486 14.5607 4.35355L10.6464 0.43934C10.3651 0.158035 9.98361 0 9.58579 0L5 0ZM13.7929 5H10.5C10.2239 5 10 4.77614 10 4.5V1.20711L13.7929 5ZM4.5 17C6.98528 17 9 14.9853 9 12.5C9 10.0147 6.98528 8 4.5 8C2.01472 8 0 10.0147 0 12.5C0 14.9853 2.01472 17 4.5 17ZM2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464C2.34171 11.9512 2.65829 11.9512 2.85355 12.1464L4 13.2929L4 10.5C4 10.2239 4.22386 10 4.5 10C4.77614 10 5 10.2239 5 10.5V13.2929L6.14645 12.1464C6.34171 11.9512 6.65829 11.9512 6.85355 12.1464C7.04882 12.3417 7.04882 12.6583 6.85355 12.8536L4.85355 14.8536C4.80561 14.9015 4.75036 14.9377 4.69139 14.9621C4.63331 14.9861 4.5697 14.9996 4.503 15L4.5 15L4.497 15C4.4303 14.9996 4.36669 14.9861 4.30861 14.9621C4.25051 14.938 4.19602 14.9026 4.14857 14.8557L4.14605 14.8532L2.14645 12.8536Z",
    fill: "#685879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadShape);
export default __webpack_public_path__ + "static/media/DownloadShape.9dcee03d48b11d20e76de69dc2a6cdc7.svg";
export { ForwardRef as ReactComponent };